import request from '@/utils/request'

export async function getCheckInForm() {
  const response = await request.get('/forms/check-in-form')
  return response.data.data
}

export async function submitCheckInForm(data) {
  const response = await request.post('/forms/check-in-form/results', data)
  return response.data.data
}